export const weightLoss = {
  program: '{{program}} Program',
  shareYourGoals: 'Build your weight loss profile with a quick assessment',
  personalizeMedication: 'Personalize your medication and program to fit your goals.',
  step: 'Step',
  yourGoals: 'Your goals',
  goal: 'Goal',
  yourCurrentHealth: 'Your current health',
  months: 'months',
  loseUpTo: 'Lose up to',
  averageWeight:
    '*Average weight loss based on 68 and 72 week clinical trials studying Semaglutide (2.4 mg) and Tirzepatide (10-15 mg) in patients without diabetes and with BMI ≥30, or BMI ≥27 with a weight-related health condition, the average weight loss was 15% and 20% respectively',
  letsConnect: '{{ name }}, let’s connect with your medical team to find the safest weight loss program for you!',
  meetWithMedicalTeam: 'Let’s meet with your medical team for your 1-on-1 consultation.',
  weReview: 'We’ll review your BMI and risk factors. Please choose a convenient time to meet.',
  withMedicalTeam: 'During your consultation, we’ll personalize your program:',
  glp: 'GLP-1 medication options',
  coaching: 'Health & wellness coaching',
  oneOnOne: '1-on-1 medical support',
  getStarted: 'Ready to get started?',
  primeWeightLoss: '{{program}} Subscription',
  perMonth: 'Per month',
  confirmSub:
    'By confirming your subscription, you allow Next Level Medical to charge you for future payments in accordance with their terms. You can always cancel your subscription.',
  yourVisit: 'Your visit with',
  programReviewReady:
    'The {{program}} program we’ve discussed is ready for review. If all looks good, subscribe today to get started!',
  planReviewReady: 'Your personalized weight loss plan is ready for review!',
  subConfirmed: 'Your {{program}} subscription is confirmed!',
  weNotify: 'We’ll notify you when your medication has been shipped out for delivery',
  weCharge: 'We’ll charge {{ currency }}{{ price }} on the ',
  weChargeMonth: '{{ day }} of ',
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
  every: 'every ',
  everyInterval: 'every {{ interval }} ',
  yourPrescription: 'Your prescription has been ordered!',
  subscribe: 'Subscribe',
  subscriptionPayment: 'Subscription payment',
  followUp: 'Let’s touch base and track your weight loss progress for {{ month }}, {{ name }}!',
  medialTeamReady: 'Your medical team is ready to review and renew your prescription',
  prescription: 'Your prescription & dosage',
  weekly: '{{ amount }} weekly',
  tirzepatide: 'Tirzepatide',
  prescriptionDelivery: 'Your prescription delivery',
  estimatedDelivered: 'Your prescription is estimated to be delivered by',
  workingDays: '{{ date }} business working days.',
  manage: 'Manage how you’re feeling, including side effects',
  adjustMedication: 'Adjust your medication dosage as needed',
  pleaseChoose: 'Please choose a time that works for you.',
  now: 'Now',
  noSlots: 'All appointments are booked for this date. Please select another day.',
  linkForJoin: 'We’ll send you a link to join the waiting room online at:',
  interestedIn: 'Interested in getting access? Let’s your employer know you’d like to learn more.',
  notSurePrimeStatus: 'Not sure about your Prime status?',
  allSetAccess: 'Let’s make sure you’re all set to access your membership.',
  calcData: 'Just a moment, we’re getting your data',
  addressYourConcerns: 'Address your concerns, monitor side effects, and ensure your health stays on track.',
  getExpertTips:
    'Get expert tips on activity and nutrition to stay motivated and move closer to your weight loss goals – one step at a time.',
  receiveMentaEmotionalsupport:
    'Receive the emotional and mental health support you need to feel confident and supported throughout your journey.',
  currentlyEnrolled:
    'This person is currently enrolled in the weight loss program. Please select another patient to enroll.',
  timeSlotNoAvailable: 'This time slot is no longer available. Please select a different one.',
  title: {
    excitedToBuild: 'Hi {{ name }}! We’re excited to build a personalized weight loss program with you!',
    exclusivelyPrimeMembers: 'Our {{program}} program is available exclusively to members of Next Level Prime. ',
    whatWouldYouLike: 'What would you like to ',
    achieve: 'achieve ',
    withTheProgram: 'with the program?',
    whatIsYour: 'What is your ',
    currentWeight: 'current weight',
    currentHeight: 'current height',
    yourPotentialWeightLoss: 'Your potential weight loss',
    combinedWithGlp: 'With GLP-1 and our program, you’ll see meaningful progress toward your goals in just ',
    threeMonths: '3 months',
    calculatingWeight: 'Just a moment, we’re calculating your potential weight loss...',
    estimatedMilestones: 'Your estimated milestones based on clinically proven weight loss treatments*',
    connectMedicalTeam: 'Connect with your medical team',
    planBuild: 'Congratulations! You’re a great fit for our program!',
    medicationOptions: 'Medication options you’ll discuss:',
    potentialWeightLoss: 'Your potential weight loss',
    sendingResponses: 'Thanks, {{ name }}! We’re creating your weight loss profile now...',
    needMoreInfo: 'Need more information before subscribing?',
    yourSub: 'Your subscription',
    personalizedPlan: 'Personalized weight loss plan',
    glp: 'GLP-1 medication',
    labs: 'Labs',
    medicalSupport: 'Medical support',
    nutrition: 'Nutrition & exercise',
    thankYou: 'Thank you for meeting with me, {{ name }}!',
    congrats: 'Congrats, {{ name }}! You’ve been subscribed to your {{program}} plan.',
    weightLossSummary: 'Here’s your weight loss summary for August, {{ name }}!',
    meetMedicalTeam: 'Would you like to meet with your medical team today?',
    letsMeet: 'Let’s meet with your medical team for your one-on-one consultation.',
    topicsCover: 'Topics we’ll cover during your consultation:',
    sendingOff: 'Sending off to your medical team now...',
    checkIn: 'Monthly Check-In',
    allSet: 'You’re all set!',
    visitStarting: 'We’re letting your weight loss medical team know that you’ve arrived...',
    primeWeight: '{{program}} Program is',
    exclusive: 'exclusive',
    toOurPrimeMembers: 'to Next Level patients in Texas.',
    interestedInWl: 'Interested in an all-inclusive weight loss program tailored just for you?',
    newLinkSent: 'A new secure link has been sent to {{ contact }}',
    didntRecieveLink: 'Didn’t receive a new link?',
    meetYourMedicalTeam: 'Meet with your medical team',
    meetYourHealthCoach: 'Meet with your health coach',
    meetYourWellnessCounselor: 'Meet with your wellness counselor',
    nextMeetTeam: 'Next, meet with your medical team to personalize and confirm your medication.',
    selectTime: 'Please select your preferred date and time.',
    confirmTime: 'Please review and confirm your visit date and time.',
    monthGoal: 'month goal',
    alreadyInProgram: 'Already in program',
    frontDoorUnavailable: 'Sorry! We’re not currently available.',
    pleaseConfirmAddress: 'Please confirm your shipping address for home delivery.',
    selectAddress: 'Select your shipping address for home delivery',
  },
  subtitle: {
    glp: '{{ medicationName }}, {{ dosageInstruction }}',
    deliveredMonthly: 'Delivered monthly',
    labs: 'Initial and follow-ups as needed',
    medicalSupport: 'Dedicated one-on-one healthcare guidance every month',
    nutrition: 'On-demand access to nutrition and wellness coaching',
    needSupport: 'Need support? We’re here for you.',
    upcomingVisit: 'Upcoming visit',
    for: 'For',
  },
  actions: {
    getStarted: 'Get Started',
    continue: 'Continue',
    next: 'Next: Your Health History',
    moreTimes: 'More times',
    schedule: 'Schedule a Consultation',
    callUs: 'Call Us',
    subscribe: 'Subscribe',
    manageSubscription: 'Manage My Subscription',
    done: 'Done',
    returnHome: 'Return Home',
    contactSupport: 'Contact for support',
    explorePrimeBenefits: 'Explore prime benefits',
    subscribeNow: 'Subscribe Now',
    billedMonthly: 'Billed {{ period }}, cancel anytime.',
    goHome: 'Go Home',
    resendLink: 'Resend link',
    linkSent: 'Link Sent',
    scheduleNow: 'Schedule Now',
    chat: 'Chat',
    call: 'Call',
    seeOtherTimes: 'See Other Times',
    getInLineNow: 'Get In Line Now',
    meetAt: 'Meet at',
    teamAvailable: 'Our medical team is available now!',
    confirm: 'Confirm',
    edit: 'Edit',
    backToSchedule: 'Back to Schedule',
    selectAnotherPerson: 'Select another person',
    manageSubs: 'Manage your subscription',
    changeAddress: 'Change shipping address',
    addNewAddress: 'Add new address',
  },
  aria: {
    previousDay: 'Previous Day',
    nextDay: 'Next Day',
    confirm: 'Confirm',
    selectAnotherPerson: 'Select another person',
    takePhoto: 'Take photo',
  },
  steps: {
    yourGoals: 'Your goals',
    currentHealth: 'Your current health',
    healthHistory: 'Your health history',
  },
  error: {
    failedToLoadShippingAddress: 'Failed to load shipping address',
    failedToSelectShippingAddress: 'Failed to select shipping address',
    invalidShippingAddress: 'Shipping address invalid, please select or add a different one',
    failedToLoadOffer: 'Failed to load offer',
  },
  today: 'Today',
  tomorrow: 'Tomorrow',
  pill: {
    weightLoss: 'Next Level Weight Loss',
  },
};
